// extracted by mini-css-extract-plugin
export default {"content":"ModalNuevoCertificado_content__W7XgA","intro":"ModalNuevoCertificado_intro__HKIYi","input":"ModalNuevoCertificado_input__00Cxe"};